import {TransactionChargeSettings} from "../../domain/types";
import {V2ChargeSettingsResponse} from "./mapper.types";

/**
 * Maps v2 API responses to domain types.
 * v2 uses camelCase so minimal transformation needed.
 *
 * Pure TypeScript - no React imports.
 */
export const ChargeSettingsMapperV2 = {
  /**
   * Maps v2 API response to domain TransactionChargeSettings.
   * Since v2 already uses camelCase, this is mostly a passthrough.
   */
  toDomain(response: V2ChargeSettingsResponse): TransactionChargeSettings {
    return {
      id: response.id,
      chargeBearer: response.chargeBearer,
      createdAt: response.createdAt,
      updatedAt: response.updatedAt,
    };
  },

  /**
   * Maps domain ChargeBearer to v2 API request payload.
   */
  toApiRequest(chargeBearer: "coach" | "customer"): {chargeBearer: "coach" | "customer"} {
    return {
      chargeBearer,
    };
  },
};
